import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts(
  'board',
  'dependent-channel-participants',
);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'impersonated_users',
  type: 'get',
  slug: [
    {
      type: 'payload',
      selector: ['dependentId'],
    },
    'chat_rooms',
    {
      type: 'payload',
      selector: ['id'],
    },
    'participants',
  ],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/board/dependent-channel-participants.js